<template>
  <div class="col border border-3">
    Arrive en cours de séance à
    {{ $moment(toLocalTime(event.date)).locale("fr").format("HH[h]mm") }},
    {{ getPersonName({ personId: event.building_owner_id }) }} ({{
      getUsedMandateTantiemesChargeGenerale(event.mandate_id)
    }}), après la résolution n°{{ voteOrder }}.
    <div
      v-if="getLastPresenceStatus(meeting.minutes, event) == mandatePresenceStatuses.correspondence"
    >
      Ceci annulera le vote par correspondance transmis par
      {{ getPersonNameAndGender({ personId: event.building_owner_id }) }}.
    </div>
    <appPresenceChanges :event="event" />
  </div>
</template>

<script>
import appPresenceChanges from "./snippets/presenceChanges.vue";
import { mandatePresenceStatuses } from "@/constants/mandate.js";
import documentsMixin from "@/mixins/documents";

export default {
  components: {
    appPresenceChanges,
  },
  mixins: [documentsMixin],
  inject: ["meeting"],
  props: ["event", "voteOrder"],
  data() {
    return {
      mandatePresenceStatuses,
    };
  },
};
</script>
